import { useLocalizedPath } from "../i18n/useLocalizedPath";
import React from "react";
import {
  Box,
  VStack,
  HStack,
  Image,
  Text,
  Heading,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { localizedNewsThumbnail, newsData } from "../data/newsData";
import { imageMap } from "../utils/imageMap";
import { getAssetLanguageKey, normalizeSiteLanguage } from "../i18n/language";
import { getNewsCopy } from "../i18n/content";

const NewsSidebar: React.FC = () => {
  const { t, i18n } = useTranslation();
  const localizePath = useLocalizedPath();
  const activeLanguage = i18n.resolvedLanguage || i18n.language;
  const assetLang = getAssetLanguageKey(activeLanguage);
  const locale = normalizeSiteLanguage(activeLanguage);

  const allNews = newsData;
  const getNewsImage = (item: (typeof newsData)[number]) => {
    const languageImage =
      localizedNewsThumbnail(item, activeLanguage) ||
      item.coverImageByLang?.[assetLang] ||
      item.imagesByLang?.[assetLang]?.[0];
    const image =
      languageImage || item.thumbnail || item.coverImage || item.images?.[0];

    return image ? imageMap[image] || image : "";
  };

  return (
    <Box
      p={6}
      bg="gray.50"
      borderRadius="lg"
    >
      <Heading as="h2" size="md" mb={4}>
        {t("news.recentNews")}
      </Heading>
      <VStack spacing={4} align="stretch">
        {allNews.map((item) => (
          <Box
            key={item.id}
            p={3}
            bg="white"
            borderRadius="md"
            cursor="pointer"
            _hover={{ bg: "blue.50" }}
            as={RouterLink}
            to={localizePath(`/news/${item.id}`)}
            aria-label={getNewsCopy(t, item.id, "title")}
          >
            <HStack spacing={3}>
              <Image
                src={getNewsImage(item)}
                alt={getNewsCopy(t, item.id, "title")}
                w="60px"
                h="60px"
                objectFit="cover"
                borderRadius="md"
                fallbackSrc="https://via.placeholder.com/60x60?text=News"
              />
              <VStack align="start" spacing={1} flex="1">
                <Text fontSize="sm" fontWeight="medium" noOfLines={2}>
                  {getNewsCopy(t, item.id, "title")}
                </Text>
                <Text fontSize="xs" color="gray.500">
                  {getNewsCopy(t, item.id, "dateDisplay") || new Date(item.date).toLocaleDateString(locale === 'en' ? 'en-US' : locale === 'zh-CN' ? 'zh-CN' : 'zh-HK')}
                </Text>
              </VStack>
            </HStack>
          </Box>
        ))}
      </VStack>
    </Box>
  );
};

export default NewsSidebar;

